module.exports = __webpack_public_path__ + "static/img/tabbt_3.96ed4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt_3.png
// module id = V8oO
// module chunks = 1